import { useEffect, useState } from 'react';

export type VisualViewportState = {
  height: number | undefined;
  offsetTop: number;
};

const initialViewport: VisualViewportState = { height: undefined, offsetTop: 0 };

/** Tracks the visible area as the mobile keyboard resizes or scrolls the viewport. */
export const useVisualViewport = (enabled = true): VisualViewportState => {
  const [viewport, setViewport] = useState(initialViewport);

  useEffect(() => {
    const visualViewport = window.visualViewport;
    if (!enabled || !visualViewport) return;

    const update = () => setViewport({ height: visualViewport.height, offsetTop: visualViewport.offsetTop });
    update();
    visualViewport.addEventListener('resize', update);
    visualViewport.addEventListener('scroll', update);
    return () => {
      visualViewport.removeEventListener('resize', update);
      visualViewport.removeEventListener('scroll', update);
    };
  }, [enabled]);

  return enabled ? viewport : initialViewport;
};
